import UsersGoalsModal from './UsersGoalsModal';

export default UsersGoalsModal;
